<!-- close -->
<button class="pos-absolute top-5 right-5"
        type="button"
        aria-label="Close"
        (click)="close()">
    <i class="icon-close"
       aria-hidden="true"></i>
</button>

<checkout-minibasket [checkoutFormComponent]="checkoutFormComponent"
                     [closePopup]="close"
                     style="height:100%;" />